<script>
    import Icon from '../icons/Icon.svelte';

    export let masterKey = '';
    export let isAuthenticating = false;
    export let authError = '';
    export let onSubmit = () => {};
    export let onBack = () => {};

    let showPassword = false;
</script>

<div class="auth-wrapper">
    <div class="auth-card">
        <!-- Logo Oficial / Cabeçalho da Autenticação no padrão MataFome Dark -->
        <div class="auth-header">
            <div class="brand-logo-container">
                <img src="./brand/matafome_logo_hero_dark.png" alt="MataFome" class="brand-logo-img" />
            </div>
            <div class="badge-row">
                <span class="auth-badge">PORTAL ADMINISTRATIVO SAAS</span>
            </div>
            <h2>Acesso Restrito ao Master</h2>
            <p>Informe a chave mestra de controle global para gerenciar lojas, faturamento e integrações.</p>
        </div>

        <form on:submit|preventDefault={onSubmit} class="auth-form">
            {#if authError}
                <div class="auth-error-banner">
                    <Icon name="alert-triangle" size={15} />
                    <span>{authError}</span>
                </div>
            {/if}

            <div class="form-group">
                <label for="master-key-input">CHAVE MESTRA DO SAAS (MASTER_KEY)</label>
                <div class="input-password-box">
                    {#if showPassword}
                        <input
                            id="master-key-input"
                            type="text"
                            bind:value={masterKey}
                            placeholder="Digite a Chave Mestra..."
                            class="form-input"
                            disabled={isAuthenticating}
                            required
                        />
                    {:else}
                        <input
                            id="master-key-input"
                            type="password"
                            bind:value={masterKey}
                            placeholder="••••••••••••••••••••••••"
                            class="form-input"
                            disabled={isAuthenticating}
                            required
                        />
                    {/if}
                    <button
                        type="button"
                        class="btn-toggle-eye"
                        on:click={() => showPassword = !showPassword}
                        tabindex="-1"
                        aria-label="Alternar visibilidade da senha"
                    >
                        <Icon name={showPassword ? 'eye-off' : 'eye'} size={15} />
                    </button>
                </div>
            </div>

            <button type="submit" class="btn-submit" disabled={isAuthenticating || !masterKey.trim()}>
                {#if isAuthenticating}
                    <span class="spinner"></span>
                    <span>Validando sessão...</span>
                {:else}
                    <Icon name="key" size={15} />
                    <span>Acessar Painel Master</span>
                {/if}
            </button>

            <button type="button" class="btn-back" on:click={onBack}>
                ← Voltar para o Login
            </button>
        </form>

        <footer class="auth-footer">
            <Icon name="lock" size={12} />
            <span>Sessão protegida por criptografia de token e rate-limiting</span>
        </footer>
    </div>
</div>

<style>
    .auth-wrapper {
        min-height: 100vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 32px 16px;
        background: radial-gradient(circle at 50% 30%, #1A1F2B 0%, #0A0D14 70%);
        box-sizing: border-box;
    }

    .auth-card {
        background: #11141C;
        border: 1px solid rgba(255, 255, 255, 0.08);
        border-radius: 20px;
        width: 100%;
        max-width: 420px;
        padding: 36px 32px 28px 32px;
        box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
        display: flex;
        flex-direction: column;
        gap: 20px;
        box-sizing: border-box;
    }

    .auth-header {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .brand-logo-container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto 16px auto;
        max-width: 180px;
    }

    .brand-logo-img {
        width: 100%;
        height: auto;
        display: block;
        object-fit: contain;
    }

    .badge-row {
        margin-bottom: 8px;
    }

    .auth-badge {
        font-size: 11px;
        font-weight: 800;
        color: #FF6A00;
        letter-spacing: 0.6px;
        text-transform: uppercase;
        background: rgba(255, 106, 0, 0.12);
        border: 1px solid rgba(255, 106, 0, 0.25);
        padding: 3px 10px;
        border-radius: 20px;
    }

    .auth-header h2 {
        font-size: 22px;
        font-weight: 800;
        color: #FFFFFF;
        margin: 0 0 6px 0;
        letter-spacing: -0.4px;
        line-height: 1.25;
    }

    .auth-header p {
        font-size: 13px;
        color: #94A3B8;
        margin: 0;
        line-height: 1.4;
    }

    .auth-form {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .auth-error-banner {
        background: rgba(239, 68, 68, 0.12);
        border: 1px solid rgba(239, 68, 68, 0.3);
        color: #F87171;
        padding: 10px 14px;
        border-radius: 8px;
        font-size: 13px;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .form-group label {
        font-size: 11px;
        font-weight: 800;
        color: #CBD5E1;
        text-transform: uppercase;
        letter-spacing: 0.6px;
    }

    .input-password-box {
        position: relative;
        display: flex;
        align-items: center;
    }

    .form-input {
        width: 100%;
        padding: 13px 42px 13px 15px;
        border-radius: 10px;
        border: 1px solid rgba(255, 255, 255, 0.12);
        font-size: 14px;
        color: #FFFFFF;
        background: #171B24;
        box-sizing: border-box;
        transition: all 0.2s ease;
    }

    .form-input:focus {
        outline: none;
        border-color: #FF6A00;
        background: #1D222E;
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.22);
    }

    .form-input::placeholder {
        color: #64748B;
    }

    .btn-toggle-eye {
        position: absolute;
        right: 12px;
        background: none;
        border: none;
        color: #64748B;
        cursor: pointer;
        padding: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: color 0.2s;
    }

    .btn-toggle-eye:hover {
        color: #FFFFFF;
    }

    .btn-submit {
        background: #FF6A00;
        border: none;
        color: #FFFFFF;
        padding: 13px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        transition: all 0.2s ease;
        box-shadow: 0 4px 14px rgba(255, 106, 0, 0.35);
    }

    .btn-submit:hover:not(:disabled) {
        background: #F97316;
        box-shadow: 0 6px 18px rgba(255, 106, 0, 0.45);
        transform: translateY(-1px);
    }

    .btn-submit:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .btn-back {
        background: transparent;
        border: none;
        color: #94A3B8;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        padding: 8px;
        transition: color 0.2s;
        text-align: center;
    }

    .btn-back:hover {
        color: #FFFFFF;
    }

    .auth-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        font-size: 11px;
        color: #64748B;
        border-top: 1px solid rgba(255, 255, 255, 0.06);
        padding-top: 14px;
    }

    .spinner {
        width: 14px;
        height: 14px;
        border: 2px solid rgba(255, 255, 255, 0.3);
        border-top-color: #fff;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
        to { transform: rotate(360deg); }
    }
</style>
